import { render } from "./SecuritySystemsView.vue?vue&type=template&id=0fe25cfc&scoped=true&ts=true"
import script from "./SecuritySystemsView.vue?vue&type=script&lang=ts"
export * from "./SecuritySystemsView.vue?vue&type=script&lang=ts"

import "./SecuritySystemsView.vue?vue&type=style&index=0&id=0fe25cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe25cfc"]])

export default __exports__